import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";
import PageProject from "./PageProject";

const PageProjects = ({ block }) => {

	const [galleryView, setGalleryView] = useState(true);
	const [fadeOut, setFadeOut] = useState(false);

	const projectHeaderRef = useRef(null);

	const handleResize = useCallback(() => {
		if (projectHeaderRef.current) {
			const height = projectHeaderRef.current.clientHeight;
			document.documentElement.style.setProperty('--project-header-height', `${height}px`);
		}
	}, []);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			handleResize();
		}, 0);

		window.addEventListener('resize', handleResize);
		
		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('resize', handleResize);
		};
	}, [handleResize]);

	const toggleView = (openGallery) => {
		if (openGallery) {
			setFadeOut(true);
			setTimeout(() => {
				setGalleryView(true);
				setFadeOut(false);
			}, 850);
		} else {
			setFadeOut(true);
			setTimeout(() => {
				setGalleryView(false);
				setFadeOut(false);
			}, 850);
		}
	}

    if (!block) return null;

	console.log('Rendering PageProjects with block:', block);

    return (
        <div className={`c-page__block`}>
			<div className={`c-projects`}>
				<div className="c-projects__header">
					<h2 className="c-projects__header__title" dangerouslySetInnerHTML={{ __html: 'Selected work' }}></h2>
					<div className="c-projects__header__view-toggle">
						<button 
							className={`c-projects__header__view-toggle__button ${galleryView ? 'state-active' : ''}`}
							onClick={() => toggleView(true)}
							aria-pressed={galleryView}
						>
							<span className="c-projects__header__view-toggle__button__label" dangerouslySetInnerHTML={{ __html: 'Gallery' }}></span>
						</button>
						<span className="c-projects__header__view-toggle__divider" aria-hidden="true" dangerouslySetInnerHTML={{ __html: ' / ' }}></span>
						<button
							className={`c-projects__header__view-toggle__button ${!galleryView ? 'state-active' : ''}`}
							onClick={() => toggleView(false)}
							aria-pressed={!galleryView}
						>
							<span className="c-projects__header__view-toggle__button__label" dangerouslySetInnerHTML={{ __html: 'List view' }}></span>
						</button>
					</div>
				</div>

				{block.project.map((project, index) => {
					return (
						<PageProject key={index} project={project} galleryView={galleryView} fadeOut={fadeOut} />
					);
				})}

				{block.wip && (
					<div className="c-mentions c-mentions--in-projects">
						<div className="l-grid">
							<div className="l-grid__col">
								<h3 className="c-mentions__heading" dangerouslySetInnerHTML={{ __html: "Under Construction" }}></h3>
								<div className="c-mentions__table">
									{block.wip.map((mention, index) => (
										<div className="c-mentions__row" key={index}>
											<div className="c-mentions__row__inner">
												{mention.project && <span className="c-mentions__project">{mention.project}</span>}
												{mention.year && <span className="c-mentions__year">{mention.year}</span>}
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PageProjects;
